import React, { useState, useRef, useEffect } from 'react'

import useSpeechRecognition from 'hooks/useSpeechRecognition'
import useAudioRecorder from 'hooks/useAudioRecorder'
import useAudioPlayer from 'hooks/useAudioPlayer'

import Icon from 'components/Icon'

export default ({
  onChange,
  onDelete,
  src = null,
  text = '',
  id = 1
}) => {
  const onStop = (blob) => {
    const fileReader = new FileReader()

    fileReader.readAsDataURL(blob)

    fileReader.onloadend = () => {
      onChange({ src: fileReader.result })
    }

    fileReader.onerror = (error) => {
      console.error('FileReader failed reading recorded blob', blob, error)
    }
  }

  const { record, isRecording, level, ready } = useAudioRecorder({ onStop })
  const { play, isPlaying, load } = useAudioPlayer({ src })
  const { result, listen } = useSpeechRecognition({ continuous: true })

  const audioRef = useRef()

  useEffect(() => listen(isRecording), [isRecording])
  useEffect(() => load(src), [src])
  useEffect(() => onChange({ text: result }), [result])

  return (
    <div className="group rounded-sm shadow-sm w-full flex items-center justify-between p-1 pr-4 space-x-4 border border-gray-200 bg-gray-50">
      <input
        value={text}
        className="w-full p-1 px-2 focus:border-primary transition duration-200 border border-gray-300"
        placeholder="Type in or dictate words.."
        onChange={({ target: { value } }) => onChange({ text: value })}
      />

      <button onClick={() => record(!isRecording)}>
        { isRecording ? (
          <Icon icon="microphone" className="fa-fw text-red-400" />
        ) : (
          <Icon icon="circle" className="fa-fw text-red-500" />
        ) }
      </button>

      <button onClick={() => play(!isPlaying)}>
        { isPlaying ? (
          <Icon icon="pause" className="fa-fw text-gray-600" />
        ) : (
          <Icon icon="play" className="fa-fw text-gray-600" />
        ) }
      </button>

      <button onClick={onDelete} className="text-gray-600 hover:text-negative">
        <Icon icon="trash" className="fa-fw" />
      </button>
    </div>
  )
}
